import React from 'react'
import './contact.css'
import { Form } from 'react-bootstrap'
import {FaPhone , FaEnvelope} from "react-icons/fa";

const Contact = () => {
  const d = new Date();
const year = d.getFullYear();
  return (
    <>
    
    <h3 className='text-center mt-5 mb-5 hr-lines' id='contact'>Contact Me</h3>
    
    <div className="container">
        
        <div className="row">
        <div className='col-lg-8 col-md-5 col-sm-12 form'>
        <Form method='POST' action='https://formspree.io/f/moqzbwdn'>

      <Form.Group className="mb-3" controlId="formBasicEmail">
       
        <input type="email" placeholder="Enter email" name='Email'  required autoComplete='off' className='inp'/>
        <br></br>
        <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text>
      </Form.Group>

       <Form.Group className="mb-3" controlId="formBasicEmail">
        <br></br>
        <input type="name" placeholder="Enter Name" name='Name'  required autoComplete='off'  className='inp'/>
        
      </Form.Group>

       <Form.Group className="mb-3" controlId="formBasicEmail">
        <br></br>
        <input type="text" placeholder="Enter Message" name='Message'  required autoComplete='off' className='inp'/>
        
      </Form.Group>

    
   <button type='submit' className='button'><span>Send Message</span></button>
    </Form>

        </div>

<div className='col-lg-4 mt-5'>
  <h3 className='mt-2 p-3 '><FaPhone className='address'/> <span>  +92 3347319447</span></h3>
  <h3 className='mt-2 p-3 '><FaEnvelope className='address'/> <span>  azeemzafar90@gmail.com</span></h3>
</div>




        </div>
        
    </div>


    <div className='footer bg-dark h-25 w-100'>
<h6 className='text-light text-center p-3'>All rights reserved © Copyright Azeem Zafar ,  {year}</h6>
    </div>
    
    </>
  )
}

export default Contact